/**
 * Error thrown when access to a resource is denied.
 *
 * This error deliberately hides the detailed reason from the client to prevent
 * information leakage about resource existence. The detailed reason is stored
 * for server-side logging only.
 *
 * Security: This prevents attackers from distinguishing between "resource doesn't
 * exist" and "you don't have permission", which could be used to enumerate resources.
 */
export class AccessDeniedError extends Error {
  public readonly name = "AccessDeniedError";

  /**
   * @param reason - Detailed reason for the denial (logged server-side only, never exposed to client)
   */
  constructor(public readonly reason: string) {
    super("Access denied");
  }
}

/**
 * Throw an AccessDeniedError with the given reason.
 * Use this for all authorization failures and resource-not-found cases
 * that occur after an authorization check.
 */
export function accessDenied(reason: string): never {
  throw new AccessDeniedError(reason);
}
